module.exports = __webpack_public_path__ + "7103a5f3f5f25cc417c62bbabf7051cd.svg";